import styled from 'styled-components';
import Box from './Box';
import { BORDER } from './constants';
import sx from './sx';
const BorderBox = styled(Box).withConfig({
  displayName: "BorderBox",
  componentId: "oreju5-0"
})(["", ";", ";"], BORDER, sx);
BorderBox.defaultProps = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.primary',
  borderRadius: 2
};
export default BorderBox;